// extracted by mini-css-extract-plugin
export default {"MONTH":"u_kkCx","month":"u_kkCx","DAY":"mDJq32","day":"mDJq32","YEAR":"VfmmOF","year":"VfmmOF","fields":"e4InfV","mobile":"xzJtBj"};